import { render, staticRenderFns } from "./AsSubTitle.vue?vue&type=template&id=c3f7ac58&scoped=true"
var script = {}
import style0 from "./AsSubTitle.vue?vue&type=style&index=0&id=c3f7ac58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f7ac58",
  null
  
)

export default component.exports